import { Order } from '@/types';

const getIsOrderEnrolled = (order: Order): boolean => {
  if (!order?.shippingAddress) {
    return false;
  }

  // check for at least 1 address line, excluding country & name
  const { address, city, state, postal } = order.shippingAddress ?? {};
  return [address, city, state, postal].some((v) => Boolean(v));
};

export default getIsOrderEnrolled;
